import { Component, OnInit, OnDestroy } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'
import { environment } from '../../../environments/environment'
import type { SaveFircResponse } from '../../interfaces/save-firc-response'
import { EVENT_NAMES } from '../../utils/events'
import type { ClientStatusResponse } from '../../interfaces/client-status-response'
import { LoaderService } from '../../services/loader-service/loader.service'

@Component({
  selector: 'app-firc-layout',
  templateUrl: './firc-layout.component.html',
  styleUrls: ['./firc-layout.component.scss'],
})
export class FircLayoutComponent implements OnInit, OnDestroy {
  storage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService
  ) { }

  private handleOnClientIsUpdated = (event: Event) => {
    const { detail } = event as CustomEvent<ClientStatusResponse>
    if (detail?.error) return
    else if (detail.data.isClient === true && detail.data.isUpdated === true) {
      this.handleNavigateToFiscal()
    }
  }

  private handleOnSubmitFirc = (event: Event) => {
    this.loaderService.updateLoader(true)
    const { detail } = event as CustomEvent<SaveFircResponse>
    if (detail?.error) return
    else if (detail.data.success === true) {
      const flow = this.router.url.split('/')[1]
      const transactionalFlow =
        flow === 'transaccional' ? this.handleNavigateToInsurance : this.handleNavigateToFiscal
      const navigate = flow === 'migrante' ? this.handleNavigateToFiscal : transactionalFlow
      navigate()
    }
  }

  private handleNavigateToFiscal = () => {
    this.router.navigate(['..', 'fiscal'], { relativeTo: this.route, replaceUrl: true })
  }

  //to active debit card flow
  // private handleNavigateToDebitCard = () => {
  //   this.router.navigate(['..', 'tarjeta'], { relativeTo: this.route, replaceUrl: true })
  // }

  private handleNavigateToInsurance = () => {
    this.router.navigate(['..', 'seguros'], { relativeTo: this.route, replaceUrl: true })
  }

  private handleOnExit = () => {
    const flow = this.router.url.split('/')[1]
    const process = this.router.url.split('/')[2]
    this.router.navigate([flow, process], { replaceUrl: true })
  }

  private handleOnBack = () => {
    const flow = this.router.url.split('/')[1]
    const process = this.router.url.split('/')[2]
    if (flow === 'flexible') {
      this.router.navigate(['..', 'simulacion'], {
        relativeTo: this.route,
        replaceUrl: true,
      })
    } else {
      if (process === 'asistido') {
        this.handleOnExit()
      }
      this.router.navigate(['..', 'foto', '1'], { relativeTo: this.route, replaceUrl: true })
    }
  }

  ngOnInit(): void {
    this.storage.set(EVENT_NAMES.fircConfig, { config: 'config' })
    window.addEventListener(EVENT_NAMES.fircOnClientStatus, this.handleOnClientIsUpdated)
    window.addEventListener(EVENT_NAMES.fircOnSubmit, this.handleOnSubmitFirc)
    window.addEventListener(EVENT_NAMES.fircOnBack, this.handleOnExit)
    window.addEventListener(EVENT_NAMES.fircOnBackStep, this.handleOnBack)
  }

  ngOnDestroy(): void {
    window.removeEventListener(EVENT_NAMES.fircOnClientStatus, this.handleOnClientIsUpdated)
    window.removeEventListener(EVENT_NAMES.fircOnSubmit, this.handleOnSubmitFirc)
    window.removeEventListener(EVENT_NAMES.fircOnBack, this.handleOnExit)
    window.removeEventListener(EVENT_NAMES.fircOnBackStep, this.handleOnBack)
  }
}
